import React from 'react'
import { Typography, Box, Grid } from '@mui/material';
import { ImageComponent } from '../../components';
import ForwardLink from '../../components/common/ForwardLink/ForwardLink'
import '../../common/theme/Legal.scss';
import '../../common/theme/UserFlowPage.scss';
import appSettings from '../../../src/appSettings';
import logo from './../../common/assets/img/agent-account-create-image.png';

const SubmissionPage = ({
}) => {

 return (
  <div className='legal agent-ciam-container'>
    <div className='legal-container'>
      <Grid container justify='space-between' className='container-styling'>
        <Grid size={{ xs: 12, lg: 5 }}>
          <ImageComponent src={logo} />
        </Grid>
        <Grid size={{ xs: 12, lg: 7 }}>
          <Box className='legalTextContainer'>          
            <Typography className='eyebrow'>American Modern | Review authorization</Typography>
            <Typography className='title'>Thank you</Typography>
            <Typography className='submission-para'>On behalf of American Modern Insurance Group, Inc. and it's insurers.<br/>With your signed authorization, we may review consumer reports about you. This process may take several weeks. We will then make a decision regarding appointment and/or system access. For questions, please call 1 (800) 759-9008 option 2.</Typography>
            <ForwardLink url={appSettings.AGENT_STOREFRONT_URL} text='Back to American Modern'></ForwardLink>
          </Box>
        </Grid>
      </Grid>
    </div>
  </div>  
  );
};

export default SubmissionPage;
